export const VISITOR_PREFIX = "Visitor#";
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const BOTNEST_MODEL_API_URL =
  process.env.REACT_APP_BOTNEST_MODEL_API_URL;

export const MESSAGE_TYPES = {
  chat: 0,
  navigation: 1,
  activity: 2,
  attachment: 3,
  log: 4,
};

export const Visitor_status = {
  inactive: 0,
  active: 1,
  idle: 2,
};

/** Aligned with dashboard v2 / APIs / chat-widget: 0 none, 1 started, 2 ended.
 * Legacy chat-messages briefly wrote ended as 3 — treat both as ended when reading. */
export const chat_status = {
  no_action: 0,
  started: 1,
  ended: 2,
};

export const isChatEndedStatus = (status) =>
  status === chat_status.ended || status === 3;

export const Collections = {
  companies: "companies",
  visitors: "visitors",
  activities: "activities",
  sessions: "sessions",
  histories: "histories",
  properties: "properties",
  widgets: "widgets",
  feedbacks: "feedbacks",
  deviceTokens: "fcmTokens",
  banList: "banList",
  contacts: "contacts",
  triggers: "triggers",
  workflows: "workflows",
};

export const signedUrlExpireSeconds = 60 * 60 * 24;
